import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export const styles = {
  ScoreSection: css`
    display: flex;
    align-items: center;
    border-right: 2px solid #eee;
    width: 300px;
    height: 80px;
    justify-content: space-around;
    padding: 0 10px;
  `,
  ScoreSectionPercentage: css`
    font-weight: 700;
    font-size: 27px;
    margin-bottom: 8px;
  `,
  ScoreSectionPrivate: css`
    margin-bottom: 8px;
    margin-top: 30px;
    text-align: center;
  `,
  ScoreSectionPercentageProgress: css`
    height: 8px;
    border-radius: 5px;
    border: 1px solid ${theme.color.black};
  `,
  ScoreSectionPercentageProgressBar: css`
    background: ${theme.color.neutral40};
    width: 100px;
    height: 8px;
    border-radius: 5px;
    margin-bottom: 8px;
  `
}
